import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Backdrop, CircularProgress, Alert, Snackbar, Grid, Divider, InputAdornment, Paper } from '@mui/material';
import axios from 'axios';
import { LocationCity, CloudUpload, Save, Image as ImageIcon } from '@mui/icons-material';
import { create_district_admin, upload_image_all } from '../api/API';
import { AdminPage, SectionTitle, GREEN, LIGHT, BORDER, primaryButtonSx, subCardSx } from '../admin/AdminPageLayout';

function MainAddDistrict() {
    const [districts, setDistricts] = useState('');
    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const token = localStorage.getItem('token');
    const [images, setImages] = useState([]); // รูปภาพ
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error" | "warning" | "info"

    // ฟังก์ชันสำหรับบันทึกข้อมูลอำเภอ
    const handleSave = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                create_district_admin, { name: districts, },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.status === 200) {
                // NEW
                // const newDistrctId = 7;
                const newDistrctId = response.data.id;
                const formData = new FormData();
                // STEP 2: เตรียมอัปโหลดภาพ (image & video)
                if (Array.isArray(images)) {
                    images.forEach((img, index) => {
                        console.log("img++++", img);

                        if (img.file instanceof File) {
                            const file = img.file;
                            const fileName = file.name;

                            const extension = fileName.split('.').pop().toLowerCase();

                            const isImage = ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(extension);
                            const isVideo = ['mp4', 'mov', 'avi', 'mkv'].includes(extension);
                            const mediaType = isImage ? 'image' : isVideo ? 'vdo' : 'unknown';

                            if (mediaType === 'unknown') return;

                            formData.append("file", file);
                            formData.append("media_type", mediaType);
                            formData.append("type", img.type || 'default');
                            formData.append("place_type", "district");
                            formData.append("ref_id", newDistrctId);         // <-- ID จากการสร้าง place
                            formData.append("ref_name", 'district');

                            for (let [key, value] of formData.entries()) {
                                console.log(key, value);
                            }
                        }
                    });
                }

                const uploadRes = await axios.post(upload_image_all, formData, {
                    // const uploadRes = await axios.post("http://localhost:8080/upload_image_banner", formData, {
                    headers: {
                        Authorization: `Bearer ${token}`, // ❌ อย่าตั้ง Content-Type เอง
                    },
                });
                // console.log("uploadRes", uploadRes);

                if (uploadRes.status === 200 || uploadRes.status === 201) {
                    setSnackbarMessage("✅ ข้อมูลและรูปภาพถูกบันทึกเรียบร้อยแล้ว!");
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true); // ← ตรงนี้แสดง snackbar
                    setImages([]);

                } else {
                    setSnackbarMessage("❌ ไม่สามารถบันทึกข้อมูลได้");
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true); // ← แสดง snackbar

                }
            } else {
                throw new Error("Place creation failed");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("เกิดข้อผิดพลาดขณะเชื่อมต่อ");
        } finally {
            setLoading(false);
        }
    };

    const handleImageUpload = (e, type) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            // ลบ preview เก่าเพื่อป้องกัน memory leak
            images
                .filter((img) => img.type === type)
                .forEach((img) => {
                    if (img.preview) {
                        URL.revokeObjectURL(img.preview);
                    }
                });

            // สร้าง preview ใหม่
            const newImages = files.map((file) => ({
                type,
                file,
                name: file.name,
                entityID: null,
                preview: URL.createObjectURL(file),
            }));

            // รวมกับภาพประเภทอื่น
            const otherImages = images.filter((img) => img.type !== type);
            setImages([...otherImages, ...newImages]);
        }
    };

    return (
        <>
            <AdminPage
                icon={<LocationCity fontSize="large" />}
                title="เพิ่มจังหวัด"
                subtitle="กรอกชื่อและอัปโหลดรูปภาพประจำพื้นที่"
                maxWidth={720}
                actions={
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<Save />}
                        onClick={handleSave}
                        // disabled={!districts || loading}
                        sx={primaryButtonSx}
                    >
                        บันทึก
                    </Button>
                }
            >
                <Box component="form" noValidate autoComplete="off">
                    <SectionTitle step={1} title="ข้อมูลพื้นฐาน" />
                    <TextField
                        fullWidth
                        label="ชื่อจังหวัด"
                        variant="outlined"
                        value={districts}
                        onChange={(e) => setDistricts(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LocationCity sx={{ color: GREEN }} />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Divider sx={{ my: 3 }} />

                    <SectionTitle step={2} title="รูปภาพอำเภอ" />
                    <Box
                        sx={{
                            border: `2px dashed ${BORDER}`,
                            borderRadius: 3,
                            bgcolor: LIGHT,
                            p: 3,
                            textAlign: "center",
                        }}
                    >
                        <CloudUpload sx={{ fontSize: 48, color: GREEN }} />
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            เลือกไฟล์รูปภาพ (เลือกได้หลายไฟล์)
                        </Typography>
                        <Button
                            variant="outlined"
                            component="label"
                            startIcon={<CloudUpload />}
                            sx={{ borderRadius: 3, color: GREEN, borderColor: GREEN, bgcolor: "white" }}
                        >
                            อัพรูปอำเภอ
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                hidden
                                onChange={(e) => handleImageUpload(e, "banner")}
                            />
                        </Button>
                    </Box>

                    {/* แสดง preview banner */}
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        {images
                            .filter((img) => img.type === "banner")
                            .map((img, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <Paper variant="outlined" sx={{ ...subCardSx, p: 1.5 }}>
                                        <Box
                                            component="img"
                                            src={img.preview}
                                            alt={`banner preview ${index}`}
                                            sx={{ width: "100%", maxHeight: 150, objectFit: "cover", borderRadius: 2, display: "block" }}
                                        />
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, minWidth: 0 }}>
                                            <ImageIcon fontSize="small" sx={{ color: GREEN }} />
                                            <Typography variant="body2" noWrap sx={{ color: "#33691e" }}>
                                                {img.name}
                                            </Typography>
                                        </Box>
                                    </Paper>
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            </AdminPage>

            {/* Snackbar Success */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    variant="filled"
                    sx={{
                        width: '100%',
                        borderRadius: 3,
                        backgroundColor: snackbarSeverity === 'success' ? '#c8e6c9' : '#ffcdd2',
                        color: snackbarSeverity === 'success' ? '#2e7d32' : '#c62828',
                        fontWeight: 'bold',
                    }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            {/* Loading Overlay */}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default MainAddDistrict
